export enum LeaderboardType {
  MostWins = 'most_wins',
  MostMoneyWon = 'most_money_won',
}

export enum LeaderboardPeriodType {
  Daily = 'interval_1day',
  Weekly = 'interval_7day',
  Monthly = 'interval_30day',
  AllTime = 'interval_alltime',
}

export interface LeaderboardMetadata {
  type: LeaderboardType;
  key: string;
}
